import axios from "axios";
let ax = axios.create({});
export default ax;
